module.exports = __webpack_public_path__ + "static/media/nose.9b93070c.png";